import React from 'react';
import GiftCode from '../GiftCode/GiftCode';
import VerifyAddress from '../VerifyAddress';
export var YifteeFullCoverageView = function YifteeFullCoverageView() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GiftCode, null), /*#__PURE__*/React.createElement(VerifyAddress, null));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/YifteeFullCoverageView/index.js
// module id = 4577
// module chunks = 11